<template>
  <section class="vue-store" :class="mainClass">
    <aside class="store-sidebar" v-if="displaySidebar">
      <TaxToggle />
      <div class="store-sidebar__hamburger touch--only">
        <button
          class="store-hamburger hamburger hamburger--squeeze"
          id="js-store-hamburger"
          aria-controls="js-store-hamburger"
          aria-expanded="false"
          type="button"
          burger-button
          :class="{ 'is-active': isBurgerActive }"
          @click.prevent="toggle"
        >
          <span class="hamburger-box">
            <span class="hamburger-inner"></span>
          </span>

          <span>FILTREERI</span>
        </button>
      </div>

      <div class="store-sidebar__filters" :class="{ active: isBurgerActive }">
        <div class="filter filter--categories">
          <tree-view
            :categories="$store.state.categories"
            :title="translations.productCategories"
            :parent="0"
          />
        </div>

        <Title :title="translations.sidebarFilters" />

        <div
          class="filter"
          v-if="displaySlider /*&& $store.state.products.length*/ && !$store.state.view.isLoading"
        >
          <PriceSlider
            :min="0"
            :max="$store.getters.getHighestPrice"
            :name="translations.price"
            v-if="!$store.state.view.isLoading"
            v-on:price-min-changed="updatePriceMin"
            v-on:price-max-changed="updatePriceMax"
          />
        </div>

        <template v-for="attribute in $store.getters.getFilteredAttributeTaxonomies">
          <div
            class="filter"
            v-if="attribute.filter_type === 'slider' && !$store.state.view.isLoading"
            :key="attribute.key"
          >
            <Slider
              :min="Math.min(...attribute.options.map(option => option.slug))"
              :max="Math.max(...attribute.options.map(option => option.slug))"
              :name="attribute.label"
              v-on:min-changed="updateMin"
              v-on:max-changed="updateMax"
            />
          </div>
          <AttributeFilter
            v-if="attribute.filter_type === 'checkbox' || attribute.filter_type === 'select' && !$store.state.view.isLoading"
            :key="attribute.key"
            :attribute="attribute"
          />
        </template>
        <PreviousViews :amountToDisplay="5" />
      </div>

      <div class="store-sidebar__clear" v-if="hasActiveFilters" :class="{ active: isBurgerActive }">
        <button class="filters-clear" @click.prevent="removeFilters">
          {{ translations.emptyFilters }}
        </button>
      </div>
    <Ad />
    </aside>

    <main>
      <ProductsSearch v-if="displaySearch" />
      <transition name="fade">
        <router-view></router-view>
      </transition>
    </main>
  </section>
</template>

<script>
// @ is an alias to /src
import TreeView from "@/components/archive/filters/hierarchical/TreeView.vue";
import AttributeFilter from "@/components/archive/filters/non-hierarchical/Wells.vue";
import ProductsSearch from "@/layouts/general-ui/Search/Search.vue";
import PriceSlider from "@/layouts/general-ui/PriceSlider.vue";
import Slider from "@/layouts/general-ui/Slider.vue";
import PreviousViews from "@/layouts/archive/sidebar/PreviousViews.vue";
import Title from "@/layouts/general-ui/Title.vue";
import Ad from "@/layouts/archive/ad/ad.vue";
import TaxToggle from "@/layouts/archive/sidebar/TaxToggle.vue";

export default {
  name: "Home",
  components: {
    TreeView,
    AttributeFilter,
    ProductsSearch,
    Slider,
    PriceSlider,
    PreviousViews,
    Title,
    Ad,
    TaxToggle
  },
  data() {
    return {
      offset: 50,
      isLoading: true,
      isBurgerActive: false,
      displaySlider: ws_vue_store.archive_price_slider == "1",
      translations: {
        productCategories: ws_vue_store.translations.product_categories,
        emptyFilters: ws_vue_store.translations.empty_filters,
        sidebarFilters: ws_vue_store.translations.sidebar_filters,
        price: ws_vue_store.translations.price
      }
    };
  },
  computed: {
    hasActiveFilters() {
      if ( this.$store.getters.getActiveFiltersCount ) {
        return true;
      }
      return false;
    },
    displaySidebar() {
      if (this.$route.name === "Product") {
        return ws_vue_store.single_product_sidebar === "1";
      }
      return true;
    },
    displaySearch() {
      return ws_vue_store.use_vue_search === "1";
    },
    mainClass() {
      return {
        "vue-store--archive": this.$route.name === "Archive",
        "vue-store--single": this.$route.name === "Product"
      };
    }
  },
  created() {},
  methods: {
    updatePriceMin(value) {
      this.$store.commit('changeProductsLoadingState', true);
      this.$store.commit('updatePriceFilter', { 'value': value, 'type': 'min' } );
      //this.$store.dispatch("getFilteredAttributes", []).then(() => this.$store.dispatch("getProducts", []));
      //this.$store.state.filters.priceSlider.min = value;
    },
    updatePriceMax(value) {
      this.$store.commit('changeProductsLoadingState', true);
      this.$store.commit('updatePriceFilter', { 'value': value, 'type': 'max' } );
      this.$store.dispatch("getFilteredAttributes", []).then(() => this.$store.dispatch("getProducts", []));
      //this.$store.state.filters.priceSlider.max = value;
    },
    updateMin(value) {
      // this.$store.state.filters.priceSlider.min = value
    },
    updateMax(value) {
      // this.$store.state.filters.priceSlider.max = value
    },
    toggle() {
      this.isBurgerActive = !this.isBurgerActive;
    },
    removeFilters(){
      this.$store.commit('changeProductsLoadingState', true);
      this.$store.commit('clearFilters');
      this.$store.dispatch("getFilteredAttributes", []).then(() => this.$store.dispatch("getProducts", []));
    }
  }
};
</script>

<style scpoed lang="scss">
@import "vue-select/src/scss/vue-select.scss";

.vue-store {
  &--archive {
    display: grid;
    grid-template-columns: 0.3fr 0.7fr;
  }

  .store-sidebar {
    .filters-clear {
      padding: 1rem 2rem;
      color: $color-white;
      background-color: $color-gray;
    }

    .filter {
      margin: 4rem 0;

      &__title {
        margin-bottom: 2rem;
      }
    }
  }

  main {
    padding: 4rem 0;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
